export const TAROT_DECK_SIZE = 78;
export const MAX_TAROT_CARD_COUNT = TAROT_DECK_SIZE;
export const LARGE_TAROT_DRAW_THRESHOLD = 20;

/**
 * 将外部输入解析为合法的塔罗牌数量。
 * 返回 null 表示输入不是 1-78 之间的整数。
 */
export function parseTarotCardCount(value: unknown): number | null {
  const parsed = typeof value === 'number'
    ? value
    : (typeof value === 'string' && value.trim() !== '' ? Number(value) : Number.NaN);

  if (!Number.isInteger(parsed) || parsed < 1 || parsed > MAX_TAROT_CARD_COUNT) {
    return null;
  }

  return parsed;
}

export function isLargeTarotDraw(cardCount: number): boolean {
  return cardCount > LARGE_TAROT_DRAW_THRESHOLD;
}
